<template>
  <div id="wrapper" :class="cssWrapper()">
    <div class="header">
      <div class="content shadow">
        <div class="inner">
          <div class="logo">
            <a>
              <img class="mobile" src="@/assets/images/logo_s.svg" width="20" />
              <img class="pc" src="@/assets/images/logo.svg" width="164" />
            </a>
          </div>
          <div class="text"><p>登入首頁</p></div>
          <div class="hamburgerBox">
            <a class="hamburger hamburger--spin">
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="nav">
        <div class="caption"><p>請選擇您要使用的功能</p></div>
        <div class="inner">
          <a class="btn"
            ><div class="inner">
              <img
                class="account"
                src="@/assets/images/nav_icon/nav_icon_account.svg"
              />
              <p>會員帳號</p>
            </div></a
          >
          <a class="btn"
            ><div class="inner">
              <img
                class="reservation"
                src="@/assets/images/nav_icon/nav_icon_reservation.svg"
              />
              <p>預約掛號</p>
            </div></a
          >
          <a class="btn"
            ><div class="inner">
              <img
                class="search"
                src="@/assets/images/nav_icon/nav_icon_search.svg"
              />
              <p>掛號查詢</p>
            </div></a
          >
          <a class="btn"
            ><div class="inner">
              <img
                class="scope"
                src="@/assets/images/nav_icon/nav_icon_scope.svg"
              />
              <p>看診進度</p>
            </div></a
          >
          <a class="btn"
            ><div class="inner">
              <img
                class="notification"
                src="@/assets/images/nav_icon/nav_icon_notification.svg"
              />
              <p>推播設定</p>
            </div></a
          >
          <a class="btn"
            ><div class="inner">
              <img
                class="board"
                src="@/assets/images/nav_icon/nav_icon_board.svg"
              />
              <p>檢驗資料</p>
            </div></a
          >
          <a class="btn"
            ><div class="inner">
              <img
                class="suggestion"
                src="@/assets/images/nav_icon/nav_icon_suggestion.svg"
              />
              <p>意見反映</p>
            </div></a
          >
          <a class="btn"
            ><div class="inner">
              <img
                class="lesson"
                src="@/assets/images/nav_icon/nav_icon_lesson.svg"
              />
              <p>預約課程</p>
            </div></a
          >
        </div>
      </div>
    </div>
    <div class="kv login covershow"><div class="cover"></div></div>
    <div class="content">
      <div class="titleTxt">
        <div class="inner">
          <span></span>
          <p>請先登入會員</p>
          <span></span>
        </div>
      </div>
      <div class="formBox">
        <form action="javascript:void(0);">
          <input
            type="text"
            class="inputBox uid"
            placeholder="身分證字號"
            maxlength="11"
            v-model="loginForm.twid"
          />
          <input
            type="text"
            class="inputBox phone"
            placeholder="行動電話號碼"
            maxlength="10"
            autocomplete="tel"
            v-model="loginForm.phone"
          />
          <input
            type="password"
            class="inputBox pass"
            placeholder="您的密碼"
            v-model="loginForm.authCode"
          />
          <input type="submit" class="submitBtn" value="確認送出" />
        </form>
      </div>
      <div class="loginBtns">
        <a>申請會員</a>
        <a>忘記密碼?</a>
      </div>
      <div class="textBox">
        <p>
          外籍人士請以居留證號、護照號碼掛號，並請在號碼前加註@<br />例如：居留證號為AD12345678，請輸入
          @AD12345678 <br />For foreigners, please use Resident Certificate ID
          number or Passport number to register. Please add @ before the id
          number. For example: the Resident Certificate ID number is AD12345678,
          please type @AD12345678.
        </p>
      </div>
    </div>
  </div>

  <div v-if="view === 'fail'">
    <h3>{{ message }}</h3>
    <p>{{ params }}</p>
  </div>

  <div class="debug">
    <p>{{ member }}</p>
    <p>{{ loginForm }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      member: this.$store.state.member,
      params: null,
      loginForm: {}
    };
  },
  mounted() {
    this.params = this.$route.params;
  },
  methods: {
    btnSubmit() {
      this.$http
        .post("/api/mobile/MemberShip", {
          platform: "line",
          jwt: this.member.jwt,
          action: "login",
          data: this.loginForm
        })
        .then(response => {
          console.log(response.data);
          if (response.data.code === "success") {
            //會員資料存入Vue store
            this.$store.dispatch("login", {
              jwt: response.data.jwt,
              platform: this.params.platform,
              member: response.data.member
            });
            this.$router.replace(`/${this.params.page}`);
          } else {
            this.message = response.data.message;
            this.view = "fail";
          }
        })
        .catch(error => {
          alert(error);
        });
    },
    cssWrapper() {
      return "webKV noheader";
    }
  }
};
</script>
